import React from "react";
import NavigationBarSupervisor from "../../../components/NavigationBarSupervisor.component";
import { Redirect, Route, Switch } from "react-router-dom";
import PendingProject from "./PendingProject";
// import ProjectList from "./ProjectList";
import ProjectDetail from "./ProjectDetail";
import MainMenu from './MainMenu';
import TaskDetail from "./TaskDetail";
import TaskList from './TaskList'

import ProtectedRoute from '../../../routes/ProtectedRoute'
import ErrorPage from "../../ErrorPage";
import SEO from "../../SEO";
import { connect } from "react-redux";
import MainDashboard from "./MainDashboard";

const DashboardSPV = ({role}) => {
  return (
    <>
      {role === "supervisor" ? (
        <>
          <SEO
            title="Supervisor"
            description="User Panel"
            content="User Panel"
          />
          <NavigationBarSupervisor />
          <Switch>
            <Route exact path="/dashboard/supervisor">
              <Redirect to="/dashboard/supervisor/main-dashboard" />
            </Route>
            <Route path="/dashboard/supervisor/main-dashboard">
              <MainDashboard />
            </Route>
            <Route path="/dashboard/supervisor/user-panel">
              <MainMenu />
            </Route>
            <Route
              exact
              path="/dashboard/supervisor/task-list"
              component={TaskList}
            />
            <Route
              path="/dashboard/supervisor/task-list/:id"
              component={TaskDetail}
            />
            <Route
              exact
              path="/dashboard/supervisor/project-list"
              component={PendingProject}
            />
            <Route
              path="/dashboard/supervisor/project-list/:id"
              component={ProjectDetail}
            />
            <Route path="*" component={ErrorPage} />
          </Switch>
        </>
      ) : (
        <ErrorPage />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    role: state.login.role
  };
};

export default connect(mapStateToProps, null)(DashboardSPV);
